import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ModuleModel } from 'src/app/models/authentication/module.model';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ModuleService {

    constructor(private _httpClient: HttpClient) {

    }

    getAllModulesByPlatform(isWeb: boolean): Observable<Array<ModuleModel>> {
        return this._httpClient.get<Array<ModuleModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.module.GetAllModulesByPlatform}/${isWeb}`)
    }

    createModule(moduleModel: ModuleModel) {
        return this._httpClient.post<ModuleModel>(
            `${environment.apiCervinoBackend}${enpointCervinoWeb.module.CreateModule}`,
            moduleModel
        );
    }

    getMenuByUser(): Observable<Array<ModuleModel>> {
        return this._httpClient.get<Array<ModuleModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.module.GetMenuByUser}`)
    }

    getMenuByCompany(companyId: number): Observable<Array<ModuleModel>> {
        return this._httpClient.get<Array<ModuleModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.module.GetMenuByCompany}/${companyId}`)
    }

    getMenuByCompanyAuthenticatedByPlatform(isWeb: boolean): Observable<Array<ModuleModel>> {
        return this._httpClient.get<Array<ModuleModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.module.GetMenuByCompanyAuthenticatedByPlatform}/${isWeb}`)
    }

    getMenuByProfileUser(profileUserId: number): Observable<Array<ModuleModel>> {
        return this._httpClient.get<Array<ModuleModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.module.GetMenuByProfileUser}/${profileUserId}`)
    }

    saveModulesByCompany(companyId: number, moduleIds: Array<number>): Observable<Array<number>> {
        return this._httpClient.post<Array<number>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.module.SaveModulesByCompany}/${companyId}`,
            moduleIds)
    }

    saveModulesByProfileUser(profileUserId: number, moduleIds: Array<number>): Observable<Array<number>> {
        return this._httpClient.post<Array<number>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.module.SaveModulesByProfileUser}/${profileUserId}`,
            moduleIds)
    }
}